import { colors } from '@lmc/common/constants'
import { Suspense } from 'react'
import Field from '../../../fields'

interface EmarCurrentStockFieldProps {
  fields: Record<string, any>
  formId: string
  testId?: string
}

export default function EmarCurrentStockField(
  props: EmarCurrentStockFieldProps
): JSX.Element {
  const { fields, formId, testId } = props

  const Label = () => (
    <div
      style={styles.labelContainer}
      data-testid={
        testId ? `${testId}-current-stock-label` : 'current-stock-label'
      }
    >
      <div style={styles.label}>Current Stock</div>
      {/* @ts-ignore */}
      <div style={styles.sublabel}>You can skip this part and add later.</div>
    </div>
  )

  return (
    <div
      style={styles.container}
      data-testid={
        testId ? `${testId}-current-stock-field` : 'current-stock-field'
      }
    >
      <Label />
      <div style={styles.fieldContainer}>
        <div style={styles.field}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              formFieldStyle={{ maxWidth: 120 }}
              formId={formId}
              keys="currentStock"
              layout="no-label"
              positiveValuesOnly
              type="number"
              validationTypes="nonZero"
              values={fields}
            />
          </Suspense>
        </div>
        <div style={styles.stockUnitText}>{fields.stockQuantityType}</div>
      </div>
    </div>
  )
}

const styles = {
  container: {
    background: 'white',
    borderRadius: 15,
    padding: 16,
    marginTop: 16
  },
  field: {
    maxWidth: 120
  },
  fieldContainer: {
    alignItems: 'center',
    display: 'flex'
  },
  labelContainer: {
    marginBottom: 16
  },
  stockUnitText: {
    marginLeft: 12
  },
  label: {
    color: colors.darkgrey,
    fontSize: 12,
    lineHeight: '18px'
  }
}
